import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import store from "./redux/store";

// Auth Pages
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";

// Dashboard Pages
import Dashboard from "./pages/Dashboard/Dashboard";

// Admin Pages
import AdminDashboard from "./pages/Admin/AdminDashboard";

// Components
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout/Layout";
import Templates from "./pages/Whatsapp/Whatsapp Template/Templates";
import CreateTemplate from "./pages/Whatsapp/Whatsapp Template/CreateTemplateModal";
import SendWhatsapp from "./pages/Whatsapp/Send Whatsapp/SendWhatsapp";
import WhatsappOnboarding from "./pages/Whatsapp/WhatsApp Onboarding/WhatsappOnboarding";
import WhatsappApi from "./pages/Whatsapp/WhatsApp Api Docs/WhatsappApi";
import Chatbot from "./pages/Chatbot/Chatbot";
import ChatManagment from "./pages/Chat Managment/ChatManagment";
import CreateCampaign from "./pages/Campaigns/Create Campaign/CreateCampaign";
import CampaignReport from "./pages/Campaigns/Campaign Report/CampaignReport";
import ContactList from "./pages/Campaigns/Contact List/ContactList";

import Analytics from "./pages/Analytics/Analytics";
import Profile from "./pages/Account/Profile/Profile";
import Transaction from "./pages/Account/Transaction History/Transaction";
import ChangePassword from "./pages/Account/Change Password/ChangePassword";
import PriceList from "./pages/Account/Price List/PriceList";
import Notification from "./pages/Dashboard/Notification";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Toaster position="top-right" />
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Private Routes */}
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                {/* Dashboard Routes */}
                <Route path="/dashboard" element={<Dashboard />} />
                {/* Whatsapp Routes */}
                <Route path="whatsapp/send" element={<SendWhatsapp />} />
                <Route
                  path="whatsapp/onboarding"
                  element={<WhatsappOnboarding />}
                />
                <Route path="whatsapp/templates" element={<Templates />} />
                <Route
                  path="whatsapp/templates/create"
                  element={<CreateTemplate />}
                />
                <Route path="whatsapp/api-docs" element={<WhatsappApi />} />

                {/* chatbot routes */}
                <Route path="/chatbot" element={<Chatbot />} />

                {/* chat management routes */}
                <Route path="/chat-management" element={<ChatManagment />} />

                {/* Campaign Routes */}
                <Route path="campaign/create" element={<CreateCampaign />} />
                <Route path="campaign/report" element={<CampaignReport />} />
                <Route path="campaign/contact-list" element={<ContactList />} />
                <Route
                  path="whatsapp/templates/view/:id"
                  element={<CreateTemplate />}
                />
                <Route
                  path="whatsapp/templates/edit/:id"
                  element={<CreateTemplate />}
                />
                {/* Analytics Routes */}

                <Route path="/analytics" element={<Analytics />} />

                {/* Account Routes   */}
                <Route path="account/profile" element={<Profile />} />
                <Route path="account/transactions" element={<Transaction />} />
                <Route
                  path="account/change-password"
                  element={<ChangePassword />}
                />
                <Route path="account/pricing" element={<PriceList />} />

                {/* Other Routes  */}
                <Route path="/notifications" element={<Notification />} />

                {/* Admin Routes */}
                <Route path="/admin" element={<AdminDashboard />} />
              </Route>
            </Route>

            {/* Default Route */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
